import { v5 as uuidv5 } from 'uuid';

/* USAGE
  If your components don't have unique identifiers, use this util
  to generate consistent uuids. v5 utilizes a namespace to return
  a uuid string that will be the same every time.
  https://reactjs.org/docs/reconciliation.html#recursing-on-children
  https://stackoverflow.com/questions/52705335/will-using-uuid-to-as-list-keys-cause-unnecessary-re-renders-in-react
*/
// We need a custom namespace to pass into our uuid generator
const NAMESPACE = '00000000-0000-0000-0000-000000000000';

// Pass in the entity you want the key for
export const generateKey = (entity: object): string => uuidv5(JSON.stringify(entity), NAMESPACE);
